module.exports = __webpack_public_path__ + "static/media/paper-texture-wide.f2861936.png";